export default {
  AD_FINISHED: 'close',
  AD_STARTED: 'play',
  START_PLAYING: 'play',
  PAUSE_PLAYING: 'pause',
  SEEK: 'seek',
  STOP_PLAYING: 'stop',
  BUFFERING_WHILE_PLAYING: 'buffer',
  ERROR_WHILE_PLAYING: 'error_while_playing',
  CHANGE_PLAYING_SETTINGS: 'change_playing_settings',
  CLOSE_PLAYER: 'close',
  COMPLETE: 'complete',
  NEXT: 'next',
};
